import { BaseDocument, BaseRepository, FieldFunctions } from '../base/repository';
import firebase from 'firebase/compat';
import _firestore from '@google-cloud/firestore';
import esSchema from './location.es.schema.json';

export const locationEsSchema = esSchema;

export interface Location extends BaseDocument<Location> {
  postalCode: string;
  type: string;
  city: string;
  cityType: string;
  county: string;
  countryFips: string;
  isSeoCity: boolean;
  region: string;
  regionAbv: string;
  regionFips: string;
  msaCode: string;
  primaryAreaCode: string;
  utcOffset: number;
  timezone: string;
  dst: boolean;
  latitude: number;
  longitude: number;
}

export interface LocationSearchResults {
  id: string;
  city: string;
  latitude: number;
  longitude: number;
  postalCode: string;
  region: string;
  regionAbv: string;
}

export class LocationRepository extends BaseRepository<Location> {
  constructor(firestore: firebase.firestore.Firestore | _firestore.Firestore, fieldFunctions?: FieldFunctions) {
    super(firestore, 'postal_code_refs', fieldFunctions);
  }

  public async findByPostalCode(postalCode: string) {
    const results = await this.find({
      where: [
        { field: 'postalCode', operator: '==', value: postalCode },
      ],
      limit: 1,
    });
    return this.firstOrNull(results);
  }

  public async findByCityAndRegion(city: string, region: string) {
    const results = await this.find({
      where: [
        { field: 'city', operator: '==', value: city },
        { field: 'region', operator: '==', value: region },
      ],
    });
    return results;
  }

  public async findByCityAndRegionAbv(city: string, regionAbv: string) {
    const results = await this.find({
      where: [
        { field: 'city', operator: '==', value: city },
        { field: 'regionAbv', operator: '==', value: regionAbv },
      ],
    });
    return results;
  }
}
